module.exports = __webpack_public_path__ + "img/compress-alt.e587b5d9.svg";